import Cookies from "js-cookie";
import { showNotification } from "../utils";
import { buildApiUrl } from "./apiUrl";

const authHeader = () => ({
  Authorization: "Bearer " + Cookies.get("token"),
});

const parseErrorMessage = async (response) => {
  try {
    const data = await response.json();
    return (
      data.message || data.detail || `Error del servidor (${response.status})`
    );
  } catch {
    return `Error del servidor (${response.status})`;
  }
};

const pythonFetch = (path, options) =>
  fetch(buildApiUrl("python", path), options);

export const postPythonJson = async (path) => {
  const response = await pythonFetch(path, {
    method: "POST",
    headers: {
      ...authHeader(),
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    showNotification("Error", message, "danger");
    throw new Error(message);
  }

  return response.json();
};

export const postPythonMultipart = async (path, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await pythonFetch(path, {
    method: "POST",
    headers: authHeader(),
    body: formData,
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    showNotification("Error", message, "danger");
    throw new Error(message);
  }

  return response.json();
};

export const getPythonBlob = async (path, filename = "reporte_pace.xlsx") => {
  const response = await pythonFetch(path, {
    method: "GET",
    headers: authHeader(),
  });

  if (!response.ok) {
    const message = await parseErrorMessage(response);
    showNotification("Error", message, "danger");
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};

export class PythonService {
  static processStudents() {
    return postPythonJson("/process-students");
  }

  static downloadExcelReport() {
    return getPythonBlob("/excel-report");
  }

  static unblockAcademic(file) {
    return postPythonMultipart("/unblock-academic", file);
  }

  static initializeCounters(file) {
    return postPythonMultipart("/initialize-counters", file);
  }

  static updateZoomPasswords(file) {
    return postPythonMultipart("/update-zoom-passwords", file);
  }
}
